export enum CardColorEnum {
  common = 'common',
  primary = 'primary',
}
